module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.className
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-dd317072"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiIcon.vue
// module id = 72
// module chunks = 0